import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/format";
import { useStore } from "@/context/StoreContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useStore();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = window.location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then(({ data }) => {
        setUser(data);
        navigate(window.location.pathname || "/account", { replace: true });
      })
      .catch(() => navigate("/", { replace: true }));
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-[70vh] items-center justify-center bg-alabaster pt-28 text-center">
      <p className="font-serif text-3xl font-light text-mutedc">Signing you in…</p>
    </div>
  );
}
